import { useLayoutEffect, useState } from "react";

import eventStyle from "./event.module.css";

import Loading from "../loading/loading";

export default function Event(props) {
	const templates = props["templates"];
	const templateId = props["templateId"];
	const changeTemplate = props["changeTemplate"];
	const searchEvent = props["searchEvent"];
	const Set_searchEvent = props["Set_searchEvent"];
	const get_event = props["get_event"];

	const [eventLoading, Set_eventLoading] = useState(true);

	useLayoutEffect(() => {
		Set_eventLoading(false);
	}, []);

	return (
		<div className={eventStyle.listWrap}>
			<div
				style={{
					display: "flex",
					marginBottom: "5px",
				}}
			>
				<div
					style={{
						width: "100%",
                        height: "30px",
                        border: "0.5px solid gray",
                        boxSizing: "border-box",
                        borderRadius: "3px",
                        backgroundColor: "white",
                        overflow: "hidden"
					}}
				>
					<input
						type="text"
						name="search_word"
						placeholder="행사명 또는 설명"
						value={searchEvent}
                        style={{
                            width: "100%",
                            height: "100%",
                            border: "none",
                            outline: "none",
                            padding: "3px",
                            boxSizing: "border-box",
                            backgroundColor: "transparent"
                        }}
						onChange={(e) => Set_searchEvent(e.currentTarget.value)}
					></input>
				</div>
				<button
					type="button"
					style={{
						width: "70px",
						height: "30px",
					}}
					id=""
					onClick={(e) => changeTemplate(e)}
				>
					신규
				</button>
				<button
					type="button"
					style={{
						width: "70px",
						height: "30px",
					}}
					onClick={get_event}
				>
					검색
				</button>
			</div>

			<div className={eventStyle.eventList}>
				<Loading loading={eventLoading}></Loading>

				{templates.map((value, index) => {
					return (
						<div
							key={index}
							className={
								templateId === value["id"] ? `${eventStyle.eventButton} ${eventStyle.selected}` : eventStyle.eventButton
							}
							id={value["id"]}
							onClick={(e) => changeTemplate(e)}
						>
							<div
								style={{
									display: "flex",
									alignItems: "center",
								}}
							>
								<div
									style={{
										marginRight: "5px",
									}}
								>
									{value["name"]}
								</div>
								<div
									style={{
										fontSize: "10px",
										color: templateId === value["id"] ? "lightgray" : "gray",
									}}
								>
									{(function () {
										const description = value["description"];
										if (description) {
											return `(${description})`;
										} else {
											return "";
										}
									})()}
								</div>
							</div>
							<div>
								{(function () {
                                    if(value['updatedAt']) {
                                        const w = new Date(value["updatedAt"].toString());
                                        return w.toLocaleString("ko-KR");
                                    }
								})()}
							</div>
						</div>
					);
				})}

				{templates.length === 0 && (
					<div
						style={{
							display: "flex",
							alignItems: "center",
							justifyContent: "center",
							width: "100%",
							height: "100%",
						}}
					>
						행사가 없습니다.
					</div>
				)}
			</div>
		</div>
	);
}
